import type { CustomerRevenueReport, CustomerRevenueReportItem } from '@vy/types';
import type { Workbook } from 'exceljs';
import type { FilterField, FilterLineType } from '../../../../../components/new-design/vyTableFilter';
import { filterDateHeaders } from '../../../customer-revenue-report-page/customer-revenue-report-components/CustomerRevenueReportTable/filter-date-headers';
import { applyCustomerRevenueSearch } from '../../../customer-revenue-report-page/utils/apply-customer-revenue-search';
import { getTotalCustomerRevenueDateHeaders } from './get-total-revenue-dates';
import { buildWaterfallSheet } from './build-waterfall-sheet';
import { buildRawDataSheet } from './build-raw-data-sheet';
import { buildWaterfallSummarySheet } from './build-waterfall-summary-sheet';
import { buildAppliedFiltersSheet } from './build-applied-filters-sheet';

export type BuildCustomerRevenueExportInput = {
  filteredReportItems: CustomerRevenueReportItem[];
  searchText: string | null | undefined;
  fromDate: Date | null;
  recognizedUpTo: Date | null;
  filters: FilterLineType[];
  filterFields: FilterField[];
  totals: CustomerRevenueReport['totals'];
};

export function buildCustomerRevenueExport(
  workbook: Workbook,
  input: BuildCustomerRevenueExportInput,
): void {
  for (const worksheet of [...workbook.worksheets]) {
    workbook.removeWorksheet(worksheet.id);
  }

  const searchedItems = applyCustomerRevenueSearch(
    input.filteredReportItems,
    input.searchText,
  );

  const allDateHeaders = getTotalCustomerRevenueDateHeaders(input.filteredReportItems);
  const dateHeaders = filterDateHeaders(allDateHeaders, input.fromDate, input.recognizedUpTo);

  buildWaterfallSheet(workbook, searchedItems, dateHeaders, allDateHeaders);
  buildRawDataSheet(workbook, searchedItems, dateHeaders);
  buildWaterfallSummarySheet(workbook, searchedItems, dateHeaders);
  buildAppliedFiltersSheet(workbook, input);
}
